import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import caseDec from '../../assets/images/case_dec.png';
import bg from '../../assets/images/case_item_bg.png';

const StyledContainer = styled.div<{ $delay: number; $hidden: boolean }>`
	position: relative;
	width: 400px;
	height: 640px;
	padding: 29px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;
	z-index: 10;
	opacity: 0;
	transform: translateY(200px);
	transition:
		opacity 0.3s ease ${({ $delay }) => $delay}s,
		transform 0.3s ease ${({ $delay }) => $delay}s,
		width 0.3s ease 0.2s,
		padding 0.3s ease 0.2s,
		border-width 0.3s ease 0.2s;

	${({ $hidden }) =>
		$hidden &&
		css`
			transition:
				opacity 0.3s ease,
				transform 0.3s ease,
				width 0.3s ease 0.5s,
				padding 0.3s ease 0.5s,
				border-width 0.3s ease 0.5s !important;
			opacity: 0 !important;
			transform: translateY(200px) !important;
			width: 0 !important;
			padding: 0 !important;
			border-width: 0 !important;
		`}
`;

const StyledBg = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	mask-image: url(${bg});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${bg});
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	pointer-events: none;
`;

const StyledCaseDec = styled.div`
	position: absolute;
	top: 110px;
	left: 50%;
	transform: translateX(-50%);
	width: 340px;
	height: 340px;
	mask-image: url(${caseDec});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${caseDec});
	-webkit-mask-size: cover;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	opacity: 1;
	transition: opacity 0.3s ease;
`;

const StyledCaseDecSvg = styled.svg`
	position: absolute;
	top: 80px;
	left: 50%;
	transform: translateX(-50%);
	width: 400px;
	height: 400px;
	opacity: 1;
	transition: opacity 0.3s ease;
`;

const StyledHead = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledTitle = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px;
	padding: 0 10px;
	background: #2d70da;
	box-shadow: 0px 2px 14px rgba(45, 112, 218, 0.5);
	border-radius: 5px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledHeadRight = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledCountContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledDiscountContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	background: #ff3232;
	box-shadow: 0px 1px 14px rgba(255, 50, 50, 0.5);
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	.divider {
		display: flex;
		height: 100%;
		opacity: 0.25;
	}
`;

const StyledName = styled(Text)`
	position: relative;
	z-index: 2;
	font-weight: 500;
	font-size: 20px;
	text-align: center;
	color: #ffffff;
	margin-top: 30px;
`;

const StyledImage = styled.img`
	position: relative;
	z-index: 2;
	width: 400px;
	margin: 40px 0 0 -30px;
	object-fit: contain;
	user-select: none;
	pointer-events: none;
	transition: height 0.3s ease;
`;

const StyledBottomContainer = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
	transition:
		opacity 0.3s ease,
		margin-top 0.3s ease;

	&.bottom-enter {
		opacity: 0;
	}

	&.bottom-enter-active,
	&.bottom-enter-done,
	&.bottom-exit {
		opacity: 1;
	}

	&.bottom-exit-active {
		opacity: 0;
	}
`;

const StyledPriceContainer = styled.div<{ $hidden: boolean }>`
	display: flex;
	align-items: center;
	gap: 21px;
	margin-top: 20px;
	opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
	transition: opacity 0.3s ease;
`;

const StyledPrice = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 20px;
		color: #ffffff;
	}

	img {
		opacity: 0.5;
		margin-bottom: 1px;
	}
`;

const StyledOldPrice = styled(StyledPrice)`
	position: relative;

	img,
	${Text} {
		opacity: 0.25;
	}

	${Text} {
		font-size: 14px;
	}

	.line {
		position: absolute;
		top: 50%;
		left: -4px;
		transform: translateY(-50%);
		width: calc(100% + 8px);
		height: 1px;
		background-color: #ff3232;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledButtonsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px;
	width: 100%;
	margin-top: 30px;
`;

const StyledCountInputContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	margin-bottom: 28px;

	& > ${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export {
	StyledBg,
	StyledBottomContainer,
	StyledButtonContent,
	StyledButtonsGrid,
	StyledCaseDec,
	StyledCaseDecSvg,
	StyledContainer,
	StyledCountContainer,
	StyledCountInputContainer,
	StyledDiscountContainer,
	StyledHead,
	StyledHeadRight,
	StyledImage,
	StyledName,
	StyledOldPrice,
	StyledPrice,
	StyledPriceContainer,
	StyledTitle,
};
